module.exports = __webpack_public_path__ + "img/issue.0f53fe91.svg";